// removed by extract-text-webpack-plugin
module.exports = {"page":"ApproveEmployer_page__asFl","form":"ApproveEmployer_form__2Cn-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Admin/ApproveEmployer.scss
// module id = 683
// module chunks = 0